import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "person-heart",
  "use": "person-heart-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"person-heart\"><path d=\"M.75 17.25a6.753 6.753 0 019.4-6.208\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path clip-rule=\"evenodd\" d=\"M7.5 9a4.125 4.125 0 100-8.25A4.125 4.125 0 007.5 9zM17.25 23.25l-5.114-5.335a3.025 3.025 0 01-.567-3.492v0a3.026 3.026 0 014.846-.787l.835.835.835-.835a3.025 3.025 0 014.845.787v0a3.027 3.027 0 01-.566 3.492L17.25 23.25z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/person-heart.svg
// module id = EN0x
// module chunks = 39 44